/** Shared WebEngage-style event for “View all collections” entry points. */
export const BROWSE_ALL_COLLECTIONS_CLICKED = 'Browse All Collections Clicked';

export const BROWSE_ALL_COLLECTIONS_FROM_SOURCE_HOME_PAGE = 'Home Page';
export const BROWSE_ALL_COLLECTIONS_FROM_SOURCE_NAV_BAR = 'Nav Bar';

export function browseAllCollectionsClickedEventProperties(options: {
  fromSource: string;
  /** Product/analytics “banner name” (tile label, featured collection name, or nav category label). */
  category: string;
}): Record<string, string> {
  return {
    'From Source': options.fromSource,
    Category: options.category,
  };
}

/** Title-case slug menu id for fallback category (e.g. `all-jewellery` → `All Jewellery`). */
export function formatNavMenuIdForCategory(menuId: string): string {
  return menuId.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
